import { render, staticRenderFns } from "./PageAccess.vue?vue&type=template&id=5dd4808c&scoped=true"
import script from "./PageAccess.vue?vue&type=script&lang=js"
export * from "./PageAccess.vue?vue&type=script&lang=js"
import style0 from "./PageAccess.vue?vue&type=style&index=0&id=5dd4808c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4808c",
  null
  
)

export default component.exports